import * as React from "react";
import Treatment from "./commons/model/treatment/Treatment";
import CatalogViewer from "./commons/components/CatalogViewer";
import TreatmentViewer from "./commons/components/TreatmentViewer";
import EditAction from "./commons/components/action/EditAction";
import { AvailableEntitiesSettings } from "./commons/model/EntitySettings";
import { sanitize } from "./commons/utils/sanitize";
import { createRoot } from "react-dom/client";

interface CatalogTreatmentViewerProps {
  treatments: Treatment[];
  createUrl: string;
  assignmentUrl: string;
  entities: AvailableEntitiesSettings;
}

export default class CatalogTreatmentViewer extends React.Component<CatalogTreatmentViewerProps> {
  render() {
    return (
      <CatalogViewer<Treatment>
        itemsByType={[{ items: this.props.treatments, createUrl: this.props.createUrl }]}
        itemRenderer={this.viewer.bind(this)}
        labels={{
          title: i18n["Page.Catalog.Treatments.Title"],
          searchPlaceholder: i18n["Page.Catalog.Treatments.Search"],
          createButton: i18n["Page.Catalog.Treatments.Create"],
        }}
        itemSpacerClass={(item, nextItem) =>
          nextItem && nextItem.name[0] !== item.name[0] ? " spacer" : ""
        }
        extraContent={(item) => item.assignments.length === 0 && <i className="ic_warning" />}
        extraClasses="treatment-catalog"
        entities={this.props.entities}
      />
    );
  }

  viewer(treatment: Treatment) {
    return (
      <div className="panel with-shadow">
        {treatment.apiUrl && <EditAction href={treatment.url} />}
        <TreatmentViewer treatment={treatment} />
        <div className="assignments">
          <div className="caption">{i18n["Page.Catalog.Treatments.TreatmentAssignments"]}</div>
          <div className="h-flex">
            {treatment.assignments.length === 0 ? (
              <div className="message warning">
                <div
                  dangerouslySetInnerHTML={{
                    __html: sanitize(
                      i18n["Page.Catalog.Treatments.Warning.NoAssignment"].replace(
                        "{}",
                        this.props.assignmentUrl
                      )
                    ),
                  }}
                />
              </div>
            ) : (
              treatment.assignments.map((assignment) => (
                <span key={assignment.criteriaGroup.id}>{assignment.criteriaGroup.i18n}</span>
              ))
            )}
          </div>
        </div>
      </div>
    );
  }

  static loadComponent(elementId: string, props: CatalogTreatmentViewerProps) {
    const container = document.getElementById(elementId);
    const root = createRoot(container!);
    root.render(<CatalogTreatmentViewer {...props} />);
  }
}
